import { Injectable, Output, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpService } from './../services/http.service';
import { Globals } from '../models/globals.model';

@Injectable({
  providedIn: 'root'
})
export class PiHistoryService {

  apiUri: string;
  graphUri: string;

	getAllRunsApi = "ADF/GetAllActivityRuns ";
	refreshAllRunsApi = "ADF/UpdateAllActivityRuns";
	refreshRunApi = "ADF/UpdateActivityRun";
  createRunApi = "ADF/UpdateHistoryData";
  

  constructor(private readonly httpService: HttpService, private readonly globals: Globals, private readonly http: HttpClient) {
    this.apiUri = this.globals.config.foundationPlatformApi_client_resourceUri;
    this.graphUri = this.globals.config.graphApi_client_resourceUri;
  }

  getAllRuns() {
    return this.http.get(this.apiUri + this.getAllRunsApi);
  }

  refreshAll() {
    return this.http.get(this.apiUri + this.refreshAllRunsApi);
  }
  getUpdatedRun(runId) {
    let params = { runId: runId };

    return this.http.get(this.apiUri + this.refreshRunApi, {
      params: params
    });
  }

  addRun(RunData) {
    return this.http.post<any>(this.apiUri + this.createRunApi, RunData);
  }
}
